import type { Outcome, RiskLevel } from 'services/types';

export const STRIPE_IDS = {
  pro: '00w4gAecyc9ddld0CIcAo02',
  elite: 'fZu14o8Se2yD5SL99ecAo01',
  singleLockPick: 'aFa28sb0mddhbd5bhmcAo00',
};

export const BATCH_SIZE = 25;
export const DEFAULT_SPORT = 'nhl';
export const ENABLED_SPORTS = ['nhl', 'nba', 'nfl', 'mlb', 'wnba'];

export const STAT_PATH_MAP = {
  mlb: {
    runs: 'Runs',
    hits: 'Hits',
    homeRuns: 'Home Runs',
    earnedRuns: 'Earned Runs',
    strikeouts: 'Strikeouts',
    walks: 'Walks',
    teamScore: 'Total Runs',
    RBIs: 'RBIs',
  },
  wnba: {
    points: 'Points',
    totalRebounds: 'Total Rebounds',
    assists: 'Assists',
    threePointFieldGoalsMade: 'Three Point Field Goals Made',
    teamScore: 'Total Points',
  },
  nhl: {
    goals: 'Goals',
    assists: 'Assists',
    points: 'Points',
    teamScore: 'Total Goals',
  },
  nba: {
    points: 'Points',
    totalRebounds: 'Total Rebounds',
    assists: 'Assists',
    threePointFieldGoalsMade: 'Three Point Field Goals Made',
    teamScore: 'Total Points',
  },
  nfl: {
    rushingYards: 'Rushing Yards',
    passingYards: 'Passing Yards',
    receivingYards: 'Receiving Yards',
    receptions: 'Receptions',
    passingTouchdowns: 'Passing Touchdowns',
    rushingTouchdowns: 'Rushing Touchdowns',
    receivingTouchdowns: 'Receiving Touchdowns',
    teamScore: 'Total Points',
  },
};

export const GROUP_NAMES = {
  admin: 'Admins',
  free: 'FreePlan',
  pro: 'ProPlan',
  elite: 'ElitePlan',
};

export const RISK_LABEL: Record<RiskLevel, string> = {
  lock: 'Lock',
  fifty_fifty: '50/50',
  risky: 'Risky',
};

export const OUTCOME_LABEL: Record<Outcome, string> = {
  pending: 'Pending',
  hit: 'Hit',
  miss: 'Miss',
  void: 'Void',
};

export const formatAmericanOdds = (american: number): string => {
  if (!Number.isFinite(american)) return '—';
  return american >= 0 ? `+${american}` : `${american}`;
};

export const formatProbability = (p: number): string => `${(p * 100).toFixed(1)}%`;

export const formatThreshold = (
  operator: string,
  threshold: number,
  statPath: string,
  sport: string,
): string => {
  // "points >= 25" → "25+ points"
  const verb = operator === '>=' ? '+' : ` ${operator} `;
  if (operator === '>=' || operator === '>') {
    return `${threshold}${verb} ${STAT_PATH_MAP[sport][statPath]}`.replace(' >', '>');
  }
  return `${STAT_PATH_MAP[sport][statPath]} ${operator} ${threshold}`;
};

export const formatDate = (dateString: string): string => {
  let computedDateString = new Date(dateString).toLocaleString('UTC', {
    timeZone: 'UTC',
  });
  computedDateString = computedDateString.slice(0, computedDateString.indexOf(','));
  return computedDateString;
};
